/**
 * Storage regions offered by the bucket-config forms.
 *
 * A region id is its own label, so only the ids are listed and the option objects
 * are derived. (The app being replaced stored both, and one AWS entry had drifted
 * to a label with a trailing space.)
 */

/** https://docs.aws.amazon.com/global-infrastructure/latest/regions/aws-regions.html */
const AWS_REGION_IDS = [
  'us-east-1',
  'us-east-2',
  'us-west-1',
  'us-west-2',
  'af-south-1',
  'ap-east-1',
  'ap-east-2',
  'ap-south-1',
  'ap-south-2',
  'ap-northeast-1',
  'ap-northeast-2',
  'ap-northeast-3',
  'ap-southeast-1',
  'ap-southeast-2',
  'ap-southeast-3',
  'ap-southeast-4',
  'ap-southeast-5',
  // ap-southeast-6 does not exist yet
  'ap-southeast-7',
  'ca-central-1',
  'cn-north-1',
  'cn-northwest-1',
  'ca-west-1',
  'eu-central-1',
  'eu-central-2',
  'eu-west-1',
  'eu-west-2',
  'eu-west-3',
  'eu-south-1',
  'eu-south-2',
  'eu-north-1',
  'il-central-1',
  'me-central-1',
  'me-south-1',
  'mx-central-1',
  'sa-east-1',
] as const;

const YANDEX_REGION_IDS = ['ru-central1-a', 'ru-central1-b', 'ru-central1-c'] as const;

function toRegionOptions(ids: readonly string[]) {
  return ids.map((id) => ({ value: id, label: id }));
}

export const AWS_REGION_OPTIONS = toRegionOptions(AWS_REGION_IDS);

export const YANDEX_REGION_OPTIONS = toRegionOptions(YANDEX_REGION_IDS);
